// extracted by mini-css-extract-plugin
export default {"container":"S05_container__BoM02","limiter":"S05_limiter__cHYpI","products":"S05_products__zZxHP","precautions":"S05_precautions__wn08L"};